module.exports = __webpack_public_path__ + "static/media/y-icp.d0289dc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y-icp.png
// module id = 840
// module chunks = 2